function Dashboard() {
  return <p>Dashboard</p>;
}

export default Dashboard;
